import { observer} from 'mobx-react';
import * as React from 'react';
import { BsLock } from '@react-icons/all-files/bs/BsLock';
import {
    autoinject,
    Contract,
    Modal,
    ModalHandle,
    inject,
    deepStringFind,
    bind,
    addUnitsOfTime,
    toArray,
} from "Mri.Web.Common";
import {action, computed} from "mobx";
import {AccountsStore} from "../Accounts/AccountsStore";
import {ContractsStore} from "./ContractsStore";
import {sortBy} from "lodash";
import {AccountStore} from "../Account/AccountStore";
import {BsExclamationTriangleFill} from "@react-icons/all-files/bs/BsExclamationTriangleFill";
import {Button} from "reactstrap";
import {AccountItem} from "../Accounts/AccountItem";
import {BsPhone} from "@react-icons/all-files/bs/BsPhone";
import {BsChatSquareDots} from "@react-icons/all-files/bs/BsChatSquareDots";
import {BsBoxArrowUpRight} from "@react-icons/all-files/bs/BsBoxArrowUpRight";

export interface IContactExpirationAlertsModalProps {
    readonly modalHandle: ModalHandle;
}

@autoinject
@observer
export class ContactExpirationAlertsModal extends React.Component<IContactExpirationAlertsModalProps> {
    public render() {
        return (
            <Modal
                modalHandle={this.props.modalHandle}
                bodyClass="p-0 rounded"
                size="xl"
                onOpened={this.onOpen}
                footer={this.footer}
            >
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="text-danger f-24 p-2">
                                <span>Contract Expiration Alert! </span>
                                <span className="mx-2"><BsExclamationTriangleFill/></span>
                            </div>
                        </div>
                        <div className="col-12">
                            <table className="table table-sm table-striped fixed-header table-borderless">
                            <thead className="thead">
                                <tr>
                                    <th scope="col" className="no-wrap">
                                        Name
                                    </th>
                                    <th scope="col" className="no-wrap">
                                        Service Level
                                    </th>
                                    <th scope="col" className="no-wrap">
                                        Contract Status
                                    </th>
                                    <th scope="col" className="no-wrap">
                                        Term Length
                                    </th>
                                    <th scope="col" className="no-wrap">
                                        Start Date
                                    </th>
                                    <th scope="col" className="no-wrap">
                                        End Date
                                    </th>
                                    <th scope="col" className="no-wrap">
                                        Options
                                    </th>
                                    {this.accountStore.isInRoles(['MriAdmin']) && (
                                        <th scope="col" className="no-wrap">
                                            Active
                                        </th>
                                    )}
                                </tr>
                                </thead>

                                <tbody>
                                {this.accounts?.map(a => (
                                    <AccountItem
                                        key={a.accountNumber}
                                        account={a}
                                        forceOpen={true}
                                        contracts={this.contractsStore.accountContracts.get(a.accountNumber) || []}
                                        hideIfNoExpirations
                                        // history={this.props.history}
                                    />
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <Modal
                    className="modal-md"
                    title="Confirm Action"
                    modalHandle={this.confirmModalHandle}
                    btnClass="w-50"
                    footerClass="d-flex justify-content-center"
                >
                    Are you sure you want to dismiss this alert for <strong>30 days</strong>?
                    
                    <div className="mt-4"><i>Note: This will reset if additional contracts are due to expire.</i>
                    </div>

                    <div className="mt-2"><i>Note: Alerts will stop one month after the contracts expiration date.</i>
                    </div>
                </Modal>

                <Modal
                    className="modal-lg"
                    title="Contact Us"
                    modalHandle={this.contactModalHandle}
                    btnClass="w-50"
                    footerClass="d-flex justify-content-center"
                >
                    <div className="container-fluid h-100" id="not-found">
                        <div className="row justify-content-center">
                            <div className="col-md-4 col-xl-3 text-center pt-5 d-flex">
                                <div className="card">
                                    <div className="card-body text-center h-100">
                                        <BsPhone className="f-30"/>

                                        <p>
                                            <strong>Call Customer Support</strong>
                                        </p>

                                        <p>Give global support a call to help out with any issues you may be
                                            experiencing.</p>
                                    </div>

                                    <div className="card-footer border-0">
                                        <a className="btn btn-link" href="tel:8556744878">
                                            (855) 674-4878
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 col-xl-3 text-center pt-5 d-flex">
                                <div className="card">
                                    <div className="card-body text-center h-100">
                                        <BsChatSquareDots className="f-30"/>

                                        <p>
                                            <strong>Contact Customer Support</strong>
                                        </p>

                                        <p>Use our support channels to get in touch with customer support.</p>
                                    </div>

                                    <div className="card-footer border-0">
                                        <a className="btn btn-primary" href="https://support.mri-inc.net">
                                            {' '}
                                            <BsBoxArrowUpRight /> Support
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </Modal>
        );
    }

    @bind
    @action
    private async onOpen() {
        this.accountStore.storage.contractExpirationModalDelayDate = addUnitsOfTime(new Date(), 6, "hours");
        this.accountStore.storage.expiringAndExpiredContracts = [];

        if (this.contracts) {
            for (const contract of this.contracts) {
                const contractID = contract.serviceCO || contract.contractNumber;

                if (contractID && (contract.expiringWithin90Days() || contract.expiredRecently())) {
                    this.accountStore.storage.expiringAndExpiredContracts.push(contractID);
                }
            }
        }
    }

    @bind
    @action
    private async onDismiss() {
        if (await this.confirmModalHandle.confirm()) {
            this.accountStore.storage.contractExpirationModalDelayDate = addUnitsOfTime(new Date(), 30, "days");

            this.props.modalHandle.close();
        }
    }
    
    @bind
    @action
    private openContactUsModal() {
        this.contactModalHandle.open();
    }

    @computed
    private get footer() {
        return (
           <div>
               <Button className="mx-2" color="primary" onClick={this.openContactUsModal}>
                   Contact Support
               </Button>
               
               <Button color="primary" onClick={this.onDismiss}>
                   Dismiss for 30 days
               </Button>
           </div>
        );
    }

    @computed
    private get accounts() {
        let accounts = Array.from(this.accountsStore.accounts, ([k, v]) => v);
        accounts = sortBy(accounts, a => a.accountName);

        return accounts;
    }

    @computed
    private get contracts(): Contract[] {
        return toArray(this.contractsStore.contracts);
    }

    private confirmModalHandle: ModalHandle = new ModalHandle();
    private contactModalHandle: ModalHandle = new ModalHandle();
    @inject
    private accountStore!: AccountStore;
    @inject
    private accountsStore!: AccountsStore;
    @inject
    private contractsStore!: ContractsStore;
}
